import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { MdArticle, MdBarChart } from 'react-icons/md';

const API = process.env.REACT_APP_API_URL || '';

export default function BoxOfficeMainPage({ user }) {
  const [latestReport, setLatestReport] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchLatestReport();
  }, []);

  const fetchLatestReport = async () => {
    try {
      const res = await axios.get(`${API}/api/weekly-reports/latest`);
      setLatestReport(res.data);
      // Auto-redirect to latest report using slug (Netflix-style)
      if (res.data?.slug) {
        navigate(`/boxoffice/report/${res.data.slug}`, { replace: true });
      }
    } catch (err) {
      // 404 is fine - no reports yet
      // 404 is fine - no reports yet
    }
  };

  return (
    <div className="box-office-main-page">
      <h1 className="page-title">Box Office</h1>
      
      <div className="box-office-options">
        <div 
          className="box-office-option-card"
          onClick={() => navigate('/boxoffice/data')}
        >
          <div className="option-icon">
            <MdBarChart />
          </div>
          <h2>Box Office Data</h2>
          <p>View top 10 box office collections - All time and current year rankings</p>
        </div>

        <div 
          className="box-office-option-card"
          onClick={() => {
            if (latestReport?.slug) {
              navigate(`/boxoffice/report/${latestReport.slug}`);
            } else {
              navigate('/boxoffice/report');
            }
          }}
        >
          <div className="option-icon">
            <MdArticle />
          </div>
          <h2>Weekly Reports</h2>
          <p>{latestReport ? `Latest: ${latestReport.title}` : 'View weekly box office reports and analysis'}</p>
        </div>
      </div>
    </div>
  );
}
